import FooterComponent from './FooterComponent';

export default FooterComponent;
